import { css } from '@emotion/react'
import { Theme } from 'src/ui/style/Theme'
import 'minireset.css'

export const createGlobalCss = (th: Theme) => css`
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=optional');
    html {
        --safe-area-top: env(safe-area-inset-top, 0px);
        --safe-area-right: env(safe-area-inset-right, 0px);
        --safe-area-bottom: env(safe-area-inset-bottom, 0px);
        --safe-area-left: env(safe-area-inset-left, 0px);
        scrollbar-gutter: stable;
    }
    html[data-native-platform='android'] {
        --safe-area-top: 0px;
        --safe-area-right: 0px;
        --safe-area-bottom: 0px;
        --safe-area-left: 0px;
    }
    body {
        font-family: ${th.fonts.primary};
        font-size: ${th.fontSize.sm};
        color: ${th.fontColor.primary};
        padding: 0;
        margin: 0;
        overflow-y: scroll;
        * {
            font-family: ${th.fonts.primary};
            &:focus {
                outline: none;
            }
        }
    }
    a {
        color: ${th.colors.tertiary};
        text-decoration: none;
        &:hover {
            color: ${th.colors.secondary};
        }
    }

    p {
        line-height: 1.8;
        color: ${th.colors.darkGray};
        margin: 0 0 ${th.spacing.md};
    }

    /*
    Removes Safari default text input style https://www.youtrack.software/issue/BOXY-260
    has to be in global, because of TS error https://github.com/emotion-js/emotion/issues/2036
    */
    input[type='text'],
    input[type='email'],
    input[type='number'],
    input[type='tel'],
    input[type='password'],
    input[type='textarea'] {
        -webkit-appearance: none;
    }
`
